// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgm_a bhs_vt bhs_ea bhs_a","MenuItem__Btn":"bgm_b bhs_z","MenuItem__subtitle":"bgm_c"};